export const RegisterationText = {
  welcomTitle: "به سامانه ثبت‌نام داروخانه تپسی دارو خوش آمدید",
  welcomText: "لطفا ابتدا اطلاعات خود را وارد کنید.",
  fillFieldsForm: "لطفا اطلاعات زیر را تکمیل کتید.",
  uploadMediaInfo: "لطفا اطلاعات درخواستی را بارگذاری کنید.",
  pharmacyName: "نام داروخانه",
  pharmacyManagerName: "نام مدیر داروخانه",
  pharmacyManagerMobileNumber: "شماره تلفن همراه مدیر داروخانه",
  pharmacyManagerNationalCode: "کد ملی مدیر داروخانه",
  pharmacyTechnicalAssistantMobileNumber: "شماره تلفن همراه مسئول فنی داروخانه",
  pharmacyTechnicalAssistant: "نام مسئول فنی داروخانه",
  pharmacyPhoneNumber: "شماره ثابت داروخانه",
  pharmacyType: "نوع پروانه",
  pharmacyAddress: "آدرس داروخانه",
  cooperationType: "نوع همکاری",
  selectAddress: "انتخاب آدرس",
  addAddress: "افزودن آدرس جدید",
  noAddressDesc: "شما هیچ آدرس ثبت شده‌ای ندارید، لطفا موقعیت مکانی خود را مشخص کنید",
  thisIsYourAddress: "این آدرس نشان دهنده مکان دقیق داروخانه شماست.",
  confirmAndRegisterAddress: "تایید اطلاعات و ثبت آدرس",
  confirmAndRegister: "تایید و ثبت",
  editInfo: "ویرایش اطلاعات",
  newRegistration: "ثبت نام جدید",
  nationalImage: "تصویر کارت ملی مدیر داروخانه",
  pharmacyLicense: "تصویر پروانه تأسیس داروخانه",
  technicalAssistantLicense: "تصویر پروانه مسئول فنی داروخانه",
  confirmInfo: "آیا اطلاعات زیر را تایید می‌فرمایید؟",
  successRegistration: "درخواست شما با موفقیت ثبت شد.",
  confirmInfoTime: "بعد از ثبت داروخانه، کارشناسان ما حداکثر تا 8 ساعت (روز کاری) اطلاعات شما را بررسی می‌کنند و تایید یا عدم تایید داروخانه شما را به صورت پیامک به  اطلاع شما می‌رسانند.",
  addAddressDetail: "افزودن جزئیات آدرس",
  saveDetailsAndContinue: "ثبت جزئیات و ادامه",
  postalAddress: "آدرس پستی",
  province: "استان",
  city: "شهر",
  plaque: "پلاک",
  region: "منطقه",
};
